import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@chakra-ui/react';
import React from 'react';
import { InputVariant } from '../../core/enums';
import Input from '../input/input';
import { Select } from '../select/select';
import { styles } from './search-bar.styles';
const SearchBar = (props)=>{
    const { selectOptions, selectedOption, onSelectOptionChange, onSearchInputChange, onSearchKeyPress } = props;
    const classes = styles();
    return /*#__PURE__*/ _jsxs(Grid, {
        templateColumns: `min-content max-content`,
        sx: classes.searchBarGrid,
        children: [
            /*#__PURE__*/ _jsx(Select, {
                items: selectOptions,
                value: selectedOption,
                onChange: onSelectOptionChange,
                dataTestId: 'searchSelect',
                classes: {
                    button: classes.select
                }
            }),
            /*#__PURE__*/ _jsx(Input, {
                placeholder: 'Search',
                variant: InputVariant.SEARCH,
                label: '',
                onChange: onSearchInputChange,
                onKeyUp: onSearchKeyPress,
                dataTestId: 'searchInput',
                classes: {
                    input: classes.input,
                    leftIcon: classes.icon
                }
            })
        ]
    });
};
export { SearchBar };
